import React from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { ALERT } from "../constants/actionTypes";

import { approvePayment } from "../utils/approvePayment";

const PayPalButton =
  window.paypal && window.paypal.Buttons.driver("react", { React, ReactDOM });

const Paypal = ({ id, price, projectName, urgent }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const _createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          description: projectName,
          amount: {
            value: Math.ceil(price * 100) / 100,
          },
        },
      ],
    });
  };

  const _onApprove = async (data, actions) => {
    let order = await actions.order.capture();
    const payment = {
      reference: order.id,
      date: new Date(),
      gateway: "paypal",
      amount: Math.ceil(price * 100),
      email: order.payer.email_address,
    };
    approvePayment(
      id,
      payment,
      dispatch,
      history,
      urgent,
      Math.ceil(price * 100)
    );
  };

  const _onError = (err) => {
    console.log(err);
    dispatch({
      type: ALERT,
      payload: {
        severity: "error",
        message: "An error occurred",
        duration: 5000,
        display: true,
      },
    });
  };

  const _onCancel = () => {
    dispatch({
      type: ALERT,
      payload: {
        severity: "warning",
        message: "Transaction cancelled",
        duration: 5000,
        display: true,
      },
    });
  };

  return (
    <>
      {window.paypal && (
        <PayPalButton
          style={{
            layout: "horizontal",
            color: "blue",
            shape: "rect",
            label: "paypal",
            tagline: false,
            height: 45,
          }}
          createOrder={(data, actions) => _createOrder(data, actions)}
          onApprove={(data, actions) => _onApprove(data, actions)}
          onCancel={() => _onCancel()}
          onError={(err) => _onError(err)}
        />
      )}
    </>
  );
};

export default Paypal;
